// TODO: Remove this file after the migration to the new form's rules is complete. Don't forget to remove the import from the SingleSignUp.js and SignUp.js files. DON'T USE THIS FILE ANYWHERE ELSE.

export const changeAsyncToDeferRules = field => {
  const newRules = [];

  for (const rule of field.rules) {
    const newRule = {
      ...rule,
      type: rule.type === 'ASYNC' ? 'DEFER' : rule.type,
    };
    newRules.push(newRule);
  }

  const newField = {
    ...field,
    rules: newRules,
  };

  return newField;
};
